function imageLoadedDnd(img) {
    replaceInputImage(img);
    imageLoaded(img);
}

function imageLoaded(img) {
    hideMessage();

    if (img) {

        if (isInvalidImage(img, function(error) {showError(error);})) {
            return;
        }

        if (img.type === 'image/heif' || img.type === 'image/heic') {
            showMainSpinner();
            loadHeifImage(img, 
                function(pngFile) {
                    hideMainSpinner();
                    postPreloadImage(pngFile);
                },
                function(error) {
                    hideMainSpinner();
                    reportHeifError(window.PM_CONFIG.apiUrl, getUuid(), 'diamond-art', img, error,
                        function(response) { setUuid(response.uuid); },
                        function() {});
                    showError("da.start_error_loading_image");
                }
            );
        }
        else {
            postPreloadImage(img);
        }
    }
    else {
        showError("da.start_invalid_image_format");
    }
}

function postPreloadImage(img) {
    const apiUrl = window.PM_CONFIG.apiUrl + '/preload';
    preloadImage(apiUrl, img, 
        function(response) {
            setUuid(response.uuid);
            window.location.href = '/start-diamond-art';
        },
        function(jqXHR, textStatus, errorThrown) {
            console.log(textStatus + '-' + errorThrown);
            hideMainSpinner();
            showError("da.start_error_loading_image");
        }
    );
}

window.addEventListener('load', function(ev) {
    $("#input_image").val("");
});
